import React from "react";
import {
  NavLink
} from "react-router-dom";
import config from './../../config.js';
import Modal from './../../../components/modal.js';
import Loading from './../../../components/loading.js';

import Notification from 'rc-notification';
let notification = null;
Notification.newInstance({
  style: {
    top: '45px',
    right: 0
  }
}, (n) => notification = n);

class Aside extends React.Component {
  constructor(props) {
    super(props);
    let user = {};
    let uistyle = {};
    if (typeof localStorage.token !== 'undefined' && localStorage.token !== '') {
      user = JSON.parse(localStorage.user);
      if (typeof user.company.type !== 'undefined' && user.company.type !== '') {
        uistyle = JSON.parse(user.company.type);
      }
    }
    this.state = {
      user: user,
      modaltitle: '添加共享成员',
      ismodal: false,
      projectid: props.data.projectid,
      company_members: [], //not shared members in the company
      userids: [], //ready for add users id
      project_users: [], //shared members
      add_users: [], //ready for add users
      modaltype: '', //adduser or removeuser
      uistyle: uistyle,
      search: ''
    };
    this.addMember = this.addMember.bind(this);
    this.removeMember = this.removeMember.bind(this);

    this.modalClose = this.modalClose.bind(this);
    this.modalSubmit = this.modalSubmit.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleValueChange = this.handleValueChange.bind(this);
  }



  componentDidMount() {
    if (this.state.project_users.length) return;
    this.getProjectUsers();
  }

  handleValueChange(event) {
    const me = this;
    const target = event.target;
    const name = target.name;
    const value = target.value;
    const type = target.type;

    me.setState({
      [name]: value
    })

  }


  handleSubmit(event) {
    event.preventDefault();
    event.stopPropagation();
    const me = this;
    me.addMember();
  }


  addMember() {
    const me = this;
    let {
      company_members,
      search
    } = me.state;

    me.setState({
      modaltitle: '添加共享成员',
      ismodal: true,
      modaltype: 'adduser',
      add_users: [],
      userids: []
    });

    me.getMembers();

  }



  getMembers() {
    const me = this;
    let {
      user,
      projectid,
      search
    } = me.state;
    if (search == '') return;
    const postdata = {
      userid: user.id,
      companyid: user.company_id,
      projectid: projectid,
      Authorization: localStorage.token,
      request: 'members',
      search: search
    };
    fetch(config.host + '/project/index', {
      method: 'post',
      body: JSON.stringify(postdata)
    })
      .then(res => res.json())
      .then(json => {
        //console.log(json);
        if (json.status === 1 && json.data != false) {
          const data = json.data;
          //let members = Object.assign(this.state.company_members, data);
          me.setState({
            company_members: data
          });
        } else {
          me.setState({
            company_members: []
          });
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  }



  removeMember() {
    const me = this;
    let {
      project_users
    } = me.state;
    me.setState({
      modaltitle: '移除共享成员',
      modaltype: 'removeuser',
      ismodal: true,
      add_users: [],
      userids: []
    })

  }



  modalClose() {
    this.setState({
      ismodal: false,
      add_users: [],
      userids: []
    });
  }



  modalSubmit() {
    const me = this;
    const {
      modaltype
    } = me.state;
    if (modaltype === 'adduser') {
      me.postAddusers();
    }

    if (modaltype === 'removeuser') {
      me.postRemoveusers();
    }
  }


  postAddusers() {
    const me = this;
    const {
      userids,
      project_users,
      projectid,
      user,
      company_members,
      add_users
    } = me.state;
    if (!userids.length) {
      me.setState({
        ismodal: false
      });
      return;
    }

    const postdata = {
      userid: user.id,
      companyid: user.company_id,
      projectid: projectid,
      userids: userids,
      Authorization: localStorage.token,
      request: 'updatemembers',
      status: 1
    };

    fetch(config.host + '/project/index', {
      method: 'post',
      body: JSON.stringify(postdata)
    })
      .then(res => res.json())
      .then(json => {
        //console.log(json);
        if (json.status === 1) {
          company_members.map((m, i) => {
            userids.forEach(id => {
              if (m.id === id) delete company_members[i];
            });
          });
          let projectusers = project_users.concat(add_users);
          me.setState({
            company_members: company_members,
            project_users: projectusers,
            ismodal: false
          });
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  }


  postRemoveusers() {
    const me = this;
    const {
      userids,
      project_users,
      projectid,
      user,
      company_members,
      add_users
    } = me.state;
    if (!userids.length) {
      me.setState({
        ismodal: false
      });
      return;
    }

    const postdata = {
      userid: user.id,
      companyid: user.company_id,
      projectid: projectid,
      userids: userids,
      Authorization: localStorage.token,
      request: 'updatemembers',
      status: 0
    };

    fetch(config.host + '/project/index', {
      method: 'post',
      body: JSON.stringify(postdata)
    })
      .then(res => res.json())
      .then(json => {

        if (json.status === 1) {
          project_users.map((m, i) => {
            userids.forEach(id => {
              if (m.id === id) delete project_users[i]; //project_users.splice(i,1);
            });
          });
          me.setState({
            project_users: project_users,
            company_members: company_members.concat(add_users),
            ismodal: false
          });
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  }


  getProjectUsers() {
    const me = this;
    let {
      user,
      projectid,
      project_users
    } = me.state;
    const postdata = {
      userid: user.id,
      companyid: user.company_id,
      projectid: projectid,
      Authorization: localStorage.token,
      request: 'project_users'
    };
    fetch(config.host + '/project/index', {
      method: 'post',
      body: JSON.stringify(postdata)
    })
      .then(res => res.json())
      .then(json => {
        //console.log(json);
        if (json.status === 1) {
          const data = json.data;
          let members = Object.assign(project_users, data);
          me.setState({
            project_users: members
          });
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  }



  handleInputChange(event) {
    const me = this;
    const {
      modaltype
    } = me.state;
    if (modaltype === 'adduser') {
      me.handleAddusers(event);
    }

    if (modaltype === 'removeuser') {
      me.handleRemoveusers(event);
    }
  }



  handleAddusers(event) {
    const target = event.target;
    const value = target.value;
    const checked = target.checked;
    let {
      userids,
      company_members,
      add_users
    } = this.state;
    if (checked) {
      userids.push(value);
      company_members.map((m, i) => {
        if (m.id === value) {
          add_users.push(m);
        }
      })
    } else {
      userids.map((a, i) => {
        if (a === value) {
          userids.splice(i, 1);
        }
      });
      add_users.map((u, i) => {
        if (u.id === value) {
          add_users.splice(i, 1);
        }
      });
    }

    this.setState({
      userids: userids,
      add_users: add_users
    });
  }



  handleRemoveusers(event) {
    const target = event.target;
    const value = target.value;
    const checked = target.checked;
    let {
      userids,
      project_users,
      add_users
    } = this.state;
    if (checked) {
      userids.push(value);
      project_users.map((m, i) => {
        if (m.id === value) {
          add_users.push(m);
        }
      })
    } else {
      userids.map((a, i) => {
        if (a === value) {
          userids.splice(i, 1);
        }
      });
      add_users.map((u, i) => {
        if (u.id === value) {
          add_users.splice(i, 1);
        }
      });
    }

    this.setState({
      userids: userids,
      add_users: add_users
    });
  }



  render() {
    const {
      data
    } = this.props;
    const {
      company_members,
      project_users,
      modaltype,
      uistyle
    } = this.state;

    const links = {
      home: {
        pathname: '/console/myprojects/project/' + data.projectid + '/MR'
      },
      brainlabel: {
        pathname: '/console/myprojects/project/service_list/' + data.projectid + '/brainlabel'
      },
      vbm: {
        pathname: '/console/myprojects/project/service_list/' + data.projectid + '/vbm'
      },
      tbss: {
        pathname: '/console/myprojects/project/service_list/' + data.projectid + '/tbss'
      },
      pet: {
        pathname: '/console/myprojects/project/service_list/' + data.projectid + '/pet'
      },
      create_vbm: {
        pathname: '/console/myprojects/project/service_create/' + data.projectid + '/vbm'
      },
      create_tbss: {
        pathname: '/console/myprojects/project/service_create/' + data.projectid + '/tbss'
      },
    };


    let modalmembers = [];
    if (modaltype === 'adduser') {
      modalmembers = company_members;
    }
    if (modaltype === 'removeuser') {
      modalmembers = project_users;
    }

    return (
      <div className="aside border-left bg-white">
        <div className="sidebar-sticky">
          <div className="nav flex-column">
            <NavLink className="nav-item nav-link" activeClassName="active" to={links.home} title="Project Home Page"><i className="fa fa-home"></i> 项目首页</NavLink>
          </div>
          <h6 className="sidebar-heading px-3 mt-4 text-muted font-weight-light">查看结果</h6>
          <div className="nav flex-column">
            <NavLink className="nav-item nav-link" activeClassName="active" to={links.brainlabel} title="Brainlabel List"><i className="fa fa-brain"></i> 全脑分割</NavLink>
            {uistyle.is_pet && <NavLink className="nav-item nav-link" activeClassName="active" to={links.pet} exact title="PET List"><i className="fa fa-object-ungroup"></i> PET列表</NavLink>}
            {uistyle.is_vbm &&
              <NavLink className="nav-item nav-link" activeClassName="active" to={links.vbm} exact title="VBM List"><i className="fa fa-object-group"></i> VBM列表</NavLink>
            }
            {uistyle.is_tbss &&
              <NavLink className="nav-item nav-link" activeClassName="active" to={links.tbss} exact title="TBSS List"><i className="fa fa-file-medical-alt"></i> TBSS列表</NavLink>
            }

          </div>
          {(uistyle.is_vbm || uistyle.is_tbss) &&
            <h6 className="sidebar-heading px-3 mt-5 text-muted font-weight-light">创建任务</h6>
          }
          <div className="nav flex-column">
            {uistyle.is_vbm &&
              <NavLink className="nav-item nav-link" activeClassName="active" to={links.create_vbm} title="Create VBM Task"><i className="fa fa-plus"></i> 创建VBM任务</NavLink>
            }
            {uistyle.is_tbss &&
              <NavLink className="nav-item nav-link" activeClassName="active" to={links.create_tbss} title="Create TBSS Task"><i className="fa fa-plus"></i> 创建TBSS任务</NavLink>
            }
          </div>
          <h6 className="sidebar-heading px-3 mt-5">
            <span className="pr-3 text-muted font-weight-light"> 项目成员</span>
            <a className="px-1 text-muted" onClick={this.addMember} title="添加成员"><i className="fa fa-fw fa-user-plus"></i> </a>
            <a className="px-1 text-muted" onClick={this.removeMember} title="移除成员"><i className="fa fa-fw fa-user-times"></i> </a>
          </h6>
          <p>

          </p>
          <ol className="nav flex-column">
            {
              project_users.map((m, i) => {
                return (<li className="nav-item nav-link" key={i} title={`${m.title || ''} ${m.address || ''}  ${m.office || ''} ${m.email}`} >{m.realname || m.email} </li>)
              })
            }
          </ol>
        </div>

        <Modal title={this.state.modaltitle} display={this.state.ismodal} close={this.modalClose} submit={this.modalSubmit}>
          <div>
            {modaltype === 'adduser' &&
              <form className="form-inline" onSubmit={this.handleSubmit}>
                <div className="form-group">
                  <input type="search" name="search" className="form-control form-control-sm" placeholder="姓名、用户名、邮箱、单位、职称等" onChange={this.handleValueChange} onBlur={this.handleSubmit} value={this.state.search} style={{ 'minWidth': '260px' }} />
                </div>
                <button type="submit" className="btn btn-dark btn-sm">搜索</button>
              </form>
            }
            <ul className="list-group  list-group-flush mt-3">
              {

                modalmembers.map((m, i) => {
                  return (<li className="list-group-item list-group-item-action" key={i}><label className="form-check-label"><input type="checkbox" value={m.id} onChange={this.handleInputChange} /> <span><strong>{m.realname || ''}</strong>  {m.title || ''} {m.address || ''}  {m.office || ''} {m.email} </span></label></li>)
                })

              }
            </ul>
            {
              !modalmembers.length && <span>空</span>
            }
          </div>
        </Modal>
      </div>
    );
  }
}

export default Aside


// WEBPACK FOOTER //
// ./src/apps/console/common/aside.js